




import Vue from 'vue'

export default Vue.extend({
  name: 'XPrice',
  filters: {
    format(value: number) {
      return value.toLocaleString()
    },
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
})
